import { motion as motionTokens } from "@aio/platform-tokens";

export const TRANSITION = {
  fast: { duration: motionTokens.duration.fast / 1000, ease: [0.2, 0, 0.13, 1.5] as const },
  base: { duration: motionTokens.duration.base / 1000, ease: [0.2, 0, 0.13, 1.5] as const },
  slow: { duration: motionTokens.duration.slow / 1000, ease: [0.2, 0, 0.13, 1.5] as const },
} as const;
